import { useState } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import FileField from '../../../components/FileField'
import FormRow from '../../../components/FormRow'
import { applyLicense } from '../installService'
import { strings as S } from '../strings'

export default function LicenseDataTab({ onRun }) {
  const [file, setFile] = useState(null)

  return (
    <Card
      title={S.license.cardTitle}
      footer={
        <Button variant="primary" disabled={!file} onClick={() => onRun(() => applyLicense(file))}>
          {S.license.apply}
        </Button>
      }
    >
      <FormRow label={S.license.fileLabel} hint={S.license.fileHint}>
        {(id) => (
          <FileField
            id={id}
            name="fUldLicense"
            /* The generator writes `.json`; older files carry `.license`. The field used to
               accept anything, so a wrong pick only failed at the server. */
            accept=".json,.license,application/json"
            required
            onChange={setFile}
          />
        )}
      </FormRow>
    </Card>
  )
}
